import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";
import { ILoanSummaryRoiListItem, ITenoreListItem } from "./loanSummary.service";

export type IB2CApiResponse = {
  productWiseTenorsList: ITenoreListItem[];
  roi: ILoanSummaryRoiListItem[];
  ruralTenors: { selfemp: ITenoreListItem[]; sal: ITenoreListItem[] };
  urbanTenors: { selfemp: ITenoreListItem[]; sal: ITenoreListItem[] };
};

export type IB2CApiRequest = {
  mobileNo: string;
  offerId: string;
  processSegmentation: string;
  processType: string;
  icorsOfferType?: string;
};

export const getB2CRoi = async (
  b2cRoiRequestData: IB2CApiRequest
): Promise<IResponse<IB2CApiResponse>> => {
  const response = await encryptedRequest<IB2CApiResponse, IB2CApiRequest>({
    method: "POST",
    url: API_PATHS.b2cRoi,
    data: b2cRoiRequestData,
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};
